// DS: i3.7
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../IconWrap';
const ArrowDown = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M3.715 10.084A1 1 0 015.129 8.67l7.071 7.07 7.071-7.07a1 1 0 111.414 1.414l-7.778 7.778a1 1 0 01-1.414 0l-7.778-7.778z",
        clipRule: "evenodd"
    })));
ArrowDown.displayName = 'ArrowDown';
export default ArrowDown;
